
export const UserObj = JSON.parse(sessionStorage.getItem('user'));


